import { Component } from '@angular/core';
import { BreadcrumbComponent } from '../../../../core/layout/components/breadcrumb/breadcrumb.component';
import { MetricsCardComponent } from '../../components/metrics-card/metrics-card.component';
import { EnvDeltaStatusCardComponent } from '../../components/env-delta-status-card/env-delta-status-card.component';
import { TranslationStatusCardComponent } from '../../components/translation-status-card/translation-status-card.component';
import { LatestSynchronizationsCardComponent } from '../../components/latest-synchronizations-card/latest-synchronizations-card.component';
import { SwitchComponent } from '../../../../shared/components/form/input/switch.component';
import { OrganizationStoreService } from '../../../../shared/services/organization-store.service';

@Component({
  selector: 'app-main-page',
  imports: [
    BreadcrumbComponent,
    MetricsCardComponent,
    EnvDeltaStatusCardComponent,
    TranslationStatusCardComponent,
    LatestSynchronizationsCardComponent,
    SwitchComponent,
  ],
  templateUrl: './main-page.component.html',
})
export class MainPageComponent {
  // All Programs (aggregate across every organization) vs Program Specific (just the active org).
  programSpecific = true;

  constructor(public organizationStore: OrganizationStoreService) {}

  onModeToggle(checked: boolean): void {
    this.programSpecific = checked;
  }

  get activeOrganizationId(): string | undefined {
    return this.organizationStore.selectedOrganizationId() ?? undefined;
  }
}
